import EntityManager from '@/pages/admin/components/EntityManager';
import { newsFields, newsColumns } from '@/pages/admin/entityConfigs';

export default function NewsPage() {
  return (
    <EntityManager
      table="news"
      fields={newsFields}
      columns={newsColumns}
      orderBy="published_on"
      searchKeys={['title', 'category', 'author']}
      addLabel="Add Article"
    />
  );
}